import React from 'react';
import ToolCard from '../components/ToolCard';
import './HomePage.css';

// Tool data
const tools = [
  {
    id: 'compressor',
    name: 'Image Compressor',
    description: 'Reduce image file size while maintaining quality.',
    icon: 'compress.png'
  },
  {
    id: 'resizer',
    name: 'Image Resizer',
    description: 'Resize your images to specific dimensions.',
    icon: 'resize.png'
  },
  {
    id: 'cropper',
    name: 'Image Cropper',
    description: 'Crop unwanted parts of your image with precision.',
    icon: 'crop.png'
  },
  {
    id: 'converter',
    name: 'Format Converter',
    description: 'Convert between JPG, PNG, and WebP formats.',
    icon: 'convert.png'
  },
  {
    id: 'editor',
    name: 'Photo Editor',
    description: 'Adjust brightness, contrast, grayscale, and more.',
    icon: 'editor.png'
  },
  {
    id: 'rotator',
    name: 'Image Rotator',
    description: 'Rotate and flip your images as needed.',
    icon: 'rotator.png'
  },
  {
    id: 'watermark',
    name: 'Watermark Tool',
    description: 'Add text or image watermarks to protect your work.',
    icon: 'watermark.png'
  },
  {
    id: 'html2image',
    name: 'HTML to Image',
    description: 'Convert HTML elements to images instantly.',
    icon: 'html2img.png'
  }
];

const HomePage = () => {
  return (
    <div className="homepage">
      <div className="container">
        <div className="homepage-hero">
          <h1>All the image tools you need in one place</h1>
          <p className="homepage-subtitle">
            Free online image editing tools powered by your browser.
            No uploads required, your images stay private on your device.
          </p>
        </div>
        
        <div className="grid">
          {tools.map(tool => (
            <ToolCard key={tool.id} tool={tool} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomePage; 